import React from "react";
import "../css/Fittings.css";

const FittingsCategoryGrid = () => {
  const brochurePath =
    "/BROCHURES/B-Medical%20Gas%20Fittings%20and%20Accessories%20(2024-02-12)%20(Rev.%20B).docx.pdf";

  return (
    <div className="layout-container">
      <div className="main-content">
        <div className="section-header">
          <h2 className="product-greenBar">Medical Gas Fittings and Accessories</h2>
          <div className="green-ba"></div>
          <a href={brochurePath} download className="add-to-cart-button">
            Download Product Brochure
          </a>
        </div>

        <div className="pdf-viewer-section">
          <div className="pdf-frame">
            <iframe
              src={brochurePath}
              title="Product Brochure PDF"
              className="pdf-embed"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FittingsCategoryGrid;
